"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.planningProductionTypes = void 0;
exports.planningProductionTypes = {
    SET_ERROR: 'ADJUSTMENT PLANNING PRODUCTION TYPES REDUCER SET ERROR',
    ON_PAGE_CHANGE: 'ADJUSTMENT PLANNING PRODUCTION TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE: 'ADJUSTMENT PLANNING PRODUCTION TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'ADJUSTMENT PLANNING PRODUCTION TYPES ON MUTATION',
    ON_FILTER_CHANGE: 'ADJUSTMENT PLANNING PRODUCTION TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'ADJUSTMENT PLANNING PRODUCTION TYPES ON SAVE DATAITEM',
    ON_CHANGE_DATAITEM: 'ADJUSTMENT PLANNING PRODUCTION TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'ADJUSTMENT PLANNING PRODUCTION TYPES SET SUCCESS MODAL',
    SET_DATA_GRID_PRODUCTION: 'ADJUSTMENT PLANNING PRODUCTION TYPES GET DATA GRID',
    SET_DATA_GRID_HISTORY: 'ADJUSTMENT PLANNING PRODUCTION HISTORY TYPES GET DATA GRID',
    ON_PAGE_CHANGE_HISTORY: 'ADJUSTMENT PLANNING PRODUCTION HISTORY TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE_HISTORY: 'ADJUSTMENT PLANNING PRODUCTION HISTORY TYPES ON SORT CHANGE',
    ON_FILTER_CHANGE_HISTORY: 'ADJUSTMENT PLANNING PRODUCTION HISTORY TYPES ON FILTER CHANGE',
    SET_LAST_SUCCEED_UPLOAD: 'ADJUSTMENT PLANNING PRODUCTION HISTORY TYPES SET LAST SUCCEED UPLOAD',
};
